export const STYLES = `
:host{all:initial}
*{box-sizing:border-box;font-family:system-ui,-apple-system,"Segoe UI",sans-serif}
[hidden]{display:none!important}
button{font:inherit;cursor:pointer;color:inherit;background:none;border:0;padding:0}
button:disabled{cursor:default;opacity:.5}

/* Launcher: a Feedback pill and a round mic button, side by side; they move as one. */
.launcher{position:fixed;right:20px;bottom:20px;z-index:2147483647;display:flex;align-items:center;gap:8px;touch-action:none;user-select:none;-webkit-user-select:none}
.launcher.dragging{cursor:grabbing;opacity:.85}
.fab{display:flex;align-items:center;justify-content:center;gap:6px;height:40px;padding:0 16px;border-radius:20px;background:#18181b;color:#fff;font-size:13px;font-weight:500;box-shadow:0 4px 16px rgba(0,0,0,.25);transition:transform .12s ease-out}
.fab:hover{background:#27272a;transform:translateY(-1px)}
.mic-fab{width:40px;padding:0}
.fab svg{width:16px;height:16px;flex:none}

/* Phones: the open bar folded into one pulsing button. Recording turns it into a red timer. */
.mini{--ring:rgba(24,24,27,.45);position:fixed;z-index:2147483647;display:flex;align-items:center;justify-content:center;min-width:56px;height:56px;padding:0 18px;border-radius:28px;background:#18181b;color:#fff;box-shadow:0 6px 20px rgba(0,0,0,.3);touch-action:none;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent}
.mini svg{width:22px;height:22px}
.mini::after{content:"";position:absolute;inset:0;border-radius:inherit;pointer-events:none;animation:ring 1.8s cubic-bezier(.2,.6,.3,1) infinite}
.mini.recording{--ring:rgba(220,38,38,.65);background:#dc2626;padding:0 20px}
.mini.recording::after{animation-duration:1.2s}
.mini .time{font:600 17px/1 ui-monospace,Menlo,monospace;font-variant-numeric:tabular-nums;letter-spacing:.02em}
.mini .badge{position:absolute;top:-4px;right:-4px;min-width:22px;height:22px;padding:0 6px;border-radius:11px;background:#4f46e5;color:#fff;font:600 12px/22px system-ui,sans-serif;text-align:center;box-shadow:0 0 0 2px #fff}
.mini.dragging{opacity:.85}
@keyframes ring{0%{box-shadow:0 0 0 0 var(--ring)}70%,100%{box-shadow:0 0 0 14px transparent}}

/* Smooth entrances when switching between launcher, button and bar. */
.launcher,.mini,.bar,.toast{animation:pop .2s cubic-bezier(.2,.8,.2,1)}
@keyframes pop{from{opacity:0;scale:.92}to{opacity:1;scale:1}}
@media (prefers-reduced-motion:reduce){.launcher,.mini,.bar,.toast,.mini::after,.dot{animation:none!important}}

/* Highlight of the element under the pointer. */
.hl{position:fixed;z-index:2147483646;pointer-events:none;border:2px solid #4f46e5;background:rgba(79,70,229,.08);border-radius:4px;transition:all .06s ease-out}
.hl.flash{border-color:#16a34a;background:rgba(22,163,74,.15)}

/* The composer bar. */
.bar{position:fixed;left:50%;bottom:20px;transform:translateX(-50%);z-index:2147483647;width:min(560px,calc(100vw - 16px));display:flex;flex-direction:column;gap:8px;padding:6px 12px 10px;border-radius:16px;background:#fff;color:#18181b;font-size:13px;border:1px solid #e4e4e7;box-shadow:0 12px 40px rgba(0,0,0,.22)}
.bar.dragging{opacity:.9}
.grip{align-self:center;width:36px;height:5px;margin:0 0 2px;border-radius:3px;background:#d4d4d8;cursor:grab;touch-action:none}
.grip::before{content:"";display:block;margin:-8px -20px;height:21px}
.status{display:flex;flex-wrap:wrap;align-items:center;gap:4px 10px;font-size:12px;line-height:1.4}
.muted{color:#71717a}
.rec{display:inline-flex;align-items:center;gap:6px;font-weight:500;color:#b91c1c}
.dot{width:8px;height:8px;border-radius:50%;background:#dc2626;animation:pulse 1s infinite}
@keyframes pulse{50%{opacity:.3}}
.consent{flex:1 1 100%;color:#3f3f46}
.status .row{display:flex;gap:8px;margin-left:auto}
.small{padding:5px 10px;border-radius:8px;border:1px solid #d4d4d8;font-size:12px}
.small:hover{background:#f4f4f5}
.small.primary{background:#4f46e5;border-color:#4f46e5;color:#fff}
.chips{display:flex;flex-wrap:wrap;gap:6px}
.chip{display:inline-flex;align-items:center;gap:4px;max-width:100%;padding:3px 4px 3px 7px;border-radius:6px;background:#eef2ff;color:#3730a3;font-size:12px}
.chip .label{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.chip svg{flex:none}
.chip.voice{background:#fef2f2;color:#991b1b}
.edit-chip{background:#ecfdf5;color:#065f46}
.edit-chip .label{font:inherit;color:inherit;text-align:left}
.edit-chip s{opacity:.6}
.edit{display:flex;flex-direction:column;gap:8px}
.edit textarea{width:100%;padding:8px 10px;margin:0;border:1px solid #4f46e5;border-radius:12px;max-height:160px}
.edit .row{display:flex;align-items:center;gap:8px}
.edit .spacer{flex:1}
.toggle.on{background:#eef2ff;border-color:#c7d2fe;color:#3730a3}
.chip .x,.thumb .x{width:16px;height:16px;border-radius:50%;line-height:16px;text-align:center;font-size:13px;opacity:.7}
.chip .x:hover{opacity:1;background:rgba(0,0,0,.08)}
.thumb{position:relative;width:52px;height:38px;border-radius:6px;overflow:hidden;border:1px solid #e4e4e7}
.thumb img{width:100%;height:100%;object-fit:cover;display:block}
.thumb .x{position:absolute;top:1px;right:1px;background:rgba(0,0,0,.6);color:#fff;opacity:1}
.input{display:flex;align-items:flex-end;gap:4px;padding:4px 4px 4px 10px;border:1px solid #d4d4d8;border-radius:12px;background:#fff}
.input:focus-within{border-color:#4f46e5}
textarea{flex:1;min-width:0;min-height:24px;max-height:140px;margin:4px 0;padding:0;border:0;outline:none;resize:none;background:none;color:#18181b;font-size:14px;line-height:1.45}
textarea::placeholder{color:#a1a1aa}
.icon{flex:none;display:flex;align-items:center;justify-content:center;width:32px;height:32px;border-radius:8px;color:#52525b}
.icon:hover{background:#f4f4f5}
.icon.mic.on{background:#fee2e2;color:#dc2626}
.send{flex:none;display:flex;align-items:center;justify-content:center;min-width:32px;height:32px;padding:0 8px;border-radius:8px;background:#18181b;color:#fff;font-size:12px;white-space:nowrap}
.send.progress{background:#4f46e5;opacity:1}
.send.progress span{animation:pulse 1.2s infinite}
.foot{display:flex;align-items:center;gap:10px;min-height:20px;font-size:12px;color:#71717a}
.link{color:#4f46e5;font-size:12px}
.link:hover{text-decoration:underline}
.note{flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.voice-toggle{display:inline-flex;align-items:center;gap:4px;padding:2px 8px;border-radius:999px;border:1px solid #e4e4e7;font-size:12px;color:#71717a;white-space:nowrap}
.voice-toggle kbd{min-width:16px;padding:0 4px;border:1px solid currentColor;border-radius:4px;font:600 10px/14px ui-monospace,Menlo,monospace;text-align:center;opacity:.8}
.voice-toggle[aria-checked="true"]{border-color:#c7d2fe;background:#eef2ff;color:#3730a3}
.close{display:inline-flex;align-items:center;gap:4px;margin-left:auto;color:#71717a}
.minimize{display:inline-flex;align-items:center;gap:4px;margin-left:auto;color:#71717a}
.minimize:not([hidden])+.close{margin-left:0}
input.name{width:160px;padding:3px 8px;border:1px solid #d4d4d8;border-radius:6px;outline:none;font-size:12px;color:#18181b;background:#fff}
input.name:focus{border-color:#4f46e5}

.toast{position:fixed;z-index:2147483647;transform:translateX(-50%);max-width:calc(100vw - 16px);padding:10px 14px;border-radius:10px;background:#18181b;color:#fff;font-size:13px;box-shadow:0 4px 16px rgba(0,0,0,.25);white-space:nowrap}
.toast.err{background:#b91c1c;white-space:normal}

@media (max-width:639px){
.bar{bottom:max(8px,env(safe-area-inset-bottom));border-radius:20px;padding:8px 14px 12px;gap:10px;font-size:14px}
.status{font-size:13px}
.icon,.send{width:44px;min-width:44px;height:44px;border-radius:12px}
.icon svg,.send svg{width:20px;height:20px}
.send.progress{width:auto}
.input{padding:4px 4px 4px 12px;border-radius:14px}
.small{min-height:44px;padding:0 18px;border-radius:12px;font-size:15px}
.chip{padding:6px 6px 6px 10px;font-size:13px;border-radius:8px}
.chip .x,.thumb .x{width:28px;height:28px;line-height:28px;font-size:16px}
.thumb{width:60px;height:44px}
.foot{min-height:44px;font-size:13px}
.link,.close,.minimize{min-height:44px;padding:0 4px;font-size:14px}
.close{min-width:44px;justify-content:center}
.voice-toggle{padding:5px 10px}
.edit textarea{font-size:16px;padding:10px 12px}
.toast{font-size:14px;padding:12px 16px;white-space:normal;width:max-content;max-width:min(340px,calc(100vw - 24px));text-align:center}
}
@media (hover:none) and (pointer:coarse){
textarea,input.name{font-size:16px}
.fab{height:48px;padding:0 20px;border-radius:24px;font-size:15px}.mic-fab{width:48px;padding:0}
.fab svg{width:20px;height:20px}
.launcher{gap:10px}
.grip{width:44px;height:6px}
}
`;
